var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16540",
    "data-name": "Grupo 16540",
    transform: "translate(-320 -5263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ico_turno_virtual",
    "data-name": "Ico turno virtual",
    transform: "translate(-67 4689)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85111",
    "data-name": "Rect\\xE1ngulo 85111",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(387 574)",
    fill: "#d1f0ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sobre",
    d: "M14.2,1H3.737A3.742,3.742,0,0,0,0,4.737v8.97a3.742,3.742,0,0,0,3.737,3.737H14.2a3.742,3.742,0,0,0,3.737-3.737V4.737A3.742,3.742,0,0,0,14.2,1ZM3.737,2.495H14.2a2.242,2.242,0,0,1,2.078,1.41L10.556,9.63a2.248,2.248,0,0,1-3.172,0L1.659,3.905a2.242,2.242,0,0,1,2.078-1.41ZM14.2,15.95H3.737a2.242,2.242,0,0,1-2.242-2.242V5.859l4.832,4.829a3.743,3.743,0,0,0,5.286,0l4.832-4.829v7.849A2.242,2.242,0,0,1,14.2,15.95Z",
    transform: "translate(394 581.555)",
    fill: "#18a8a2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlue);
export default __webpack_public_path__ + "static/media/email-blue.8fa976ab246039394fe79d1a2d3d9fa0.svg";
export { ForwardRef as ReactComponent };